<template>
    <div>
        <PageHeader>
            <template #navbar>
                <Navbar />
            </template>
            <template #pagetitle>
                <PageTitle :pageTitle="$t('pages.titles.newsDetail')" />
            </template>
        </PageHeader>
        <SingleCasesStudyOne />
        <FreeTrial variant="light"/>
        <Footer />
    </div>
</template>

<script>
import Navbar from '../Layout/Navbar'
import PageHeader from '../Layout/PageHeader'
import PageTitle from '../Common/PageTitle'
import SingleCasesStudyOne from '../SingleCasesStudy/SingleCasesStudyOne'
import FreeTrial from '../Common/FreeTrial'
import Footer from '../Layout/Footer'

export default {
    name: 'SingleNewsOnePage',
    components: {
        Navbar,
        PageHeader,
        PageTitle,
        SingleCasesStudyOne,
        FreeTrial,
        Footer,
    }
}
</script>
